/** 手機載具：/ 開頭 + 7 碼英數或 . - + */
export const INVOICE_CARRIER_PATTERN = /^\/[0-9A-Z.\-+]{7}$/;

/** 捐贈碼：3–7 碼數字 */
export const INVOICE_DONATION_PATTERN = /^[0-9]{3,7}$/;

/**
 * 解析訂單結帳發票資訊（不含物流 carrier）。
 *
 * @returns {{
 *   type: 'company' | 'carrier' | 'donation' | 'personal',
 *   typeLabel: string,
 *   vatNumber: string,
 *   title: string,
 *   carrierCode: string,
 *   detailLabel: string,
 *   detailValue: string
 * }}
 */
export function getOrderCheckoutInvoice(record) {
    const vatNumber = (record?.vat_number || '').trim();
    const rawCarrier = (record?.carrier_code || '').trim();
    const title = (record?.invoice_title || '').trim();

    if (vatNumber) {
        return {
            type: 'company',
            typeLabel: '三聯式',
            vatNumber,
            title,
            carrierCode: '',
            detailLabel: title ? '抬頭' : '統編',
            detailValue: title || vatNumber
        };
    }

    if (INVOICE_CARRIER_PATTERN.test(rawCarrier)) {
        return {
            type: 'carrier',
            typeLabel: '二聯式',
            vatNumber: '',
            title: '',
            carrierCode: rawCarrier,
            detailLabel: '載具',
            detailValue: rawCarrier
        };
    }

    if (INVOICE_DONATION_PATTERN.test(rawCarrier)) {
        return {
            type: 'donation',
            typeLabel: '二聯式',
            vatNumber: '',
            title: '',
            carrierCode: rawCarrier,
            detailLabel: '捐贈',
            detailValue: rawCarrier
        };
    }

    return {
        type: 'personal',
        typeLabel: '二聯式',
        vatNumber: '',
        title: '',
        carrierCode: '',
        detailLabel: '',
        detailValue: '個人發票'
    };
}

/** 列表單行摘要（搭配 tooltip 顯示完整內容） */
export function formatCheckoutInvoiceSummary(inv) {
    if (!inv) return '—';
    if (inv.type === 'company') {
        return inv.title
            ? `${inv.vatNumber} · ${inv.title}`
            : inv.vatNumber;
    }
    if (inv.type === 'carrier' || inv.type === 'donation') {
        return `${inv.detailLabel} ${inv.detailValue}`;
    }
    return '個人發票';
}

/** tooltip 多行完整內容 */
export function formatCheckoutInvoiceTooltip(inv) {
    if (!inv) return '';
    if (inv.type === 'company') {
        const lines = [`三聯式`, `統編 ${inv.vatNumber}`];
        if (inv.title) lines.push(`抬頭 ${inv.title}`);
        return lines.join('\n');
    }
    if (inv.type === 'carrier') {
        return `二聯式\n載具 ${inv.carrierCode}`;
    }
    if (inv.type === 'donation') {
        return `二聯式\n捐贈 ${inv.carrierCode}`;
    }
    return '二聯式\n個人發票';
}
